import React from 'react';
import { Compass, Lightbulb, Users } from 'lucide-react';

export const About = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="heading-1 mb-6">
            Tentang Desy Clare
          </h2>
          
          <p className="body-large mb-8 text-gray-600 max-w-3xl mx-auto">
            Website ini adalah platform yang didedikasikan untuk membantu setiap individu memahami dirinya lebih dalam melalui ilmu numerologi dan spiritualitas. Kami percaya bahwa pemahaman dan kesadaran diri adalah langkah menuju pertumbuhan jiwa yang autentik.
          </p>
          
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-8 mb-12">
            <blockquote className="heading-3 text-amber-800 italic">
              "Knowing others is intelligence; knowing yourself is true wisdom."
            </blockquote>
            <hr className="my-4 border-amber-200" />
            <blockquote className="body-medium text-amber-600 italic">
              "Mengetahui orang lain adalah kecerdasan; mengetahui diri sendiri adalah kebijaksanaan sejati."
            </blockquote>
            <cite className="body-big text-amber-600 mt-2 block">— Lao Tzu</cite>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Compass className="h-8 w-8 text-rose-600" />
              </div>
              <h3 className="heading-3 mb-3">Panduan Personal</h3>
              <p className="body-medium text-gray-600">
                Setiap analisis dirancang khusus untuk pertumbuhan jiwa Anda.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Lightbulb className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="heading-3 mb-3">Wawasan Mendalam</h3>
              <p className="body-medium text-gray-600">
                Kombinasi ilmu numerologi, spiritualitas, dan pendekatan psikologi dengan teknologi modern.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="heading-3 mb-3">Komunitas Positif</h3>
              <p className="body-medium text-gray-600">
                Bergabung dengan komunitas yang mendukung pertumbuhan dan transformasi diri.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};